import { send } from './saveHttp';

/**
 * Hand-written client for the connector-next image/dose DELETE endpoints
 * (the generated client is not used for save-workflow mutations — see
 * `saveHttp.ts`). Deletes carry no If-Match by design: deletion is an
 * explicit, listed, user-confirmed action (same accepted posture as the
 * structure-set delete, SR-WOR-H-23-3).
 */

export async function deleteImageDataset(id: string): Promise<void> {
    await send(`/api/images/${id}`, { method: 'DELETE' });
}

export async function deleteDoseDataset(id: string): Promise<void> {
    await send(`/api/doses/${id}`, { method: 'DELETE' });
}
